module.exports = __webpack_public_path__ + "static/img/ne.b7369ec7.svg";